import { Add, DeleteOutline } from "@mui/icons-material";
import { Box, Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import { textFieldSx } from "./styles";
import { ACCENT } from "../../../../../../layout/Header/components/CreateClientModal/shared";

function BulletListEditor({ items, draft, setDraft, onAdd, onRemove, placeholder }) {
  return (
    <Stack spacing={1.5}>
      <Stack direction="row" spacing={1.5}>
        <TextField
          fullWidth
          placeholder={placeholder}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onAdd();
            }
          }}
          sx={textFieldSx}
        />
        <Button
          onClick={onAdd}
          startIcon={<Add />}
          sx={{
            color: "#1c1d16",
            background: ACCENT,
            textTransform: "none",
            borderRadius: "10px",
            px: 2,
            whiteSpace: "nowrap",
            "&:hover": { background: "#c79620" },
          }}
        >
          Add
        </Button>
      </Stack>
      <Stack spacing={1}>
        {items.map((item, index) => (
          <Box
            key={`${item}-${index}`}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "10px",
              px: 2,
              py: 1.2,
            }}
          >
            <Typography sx={{ fontSize: 14, color: "rgba(255,255,255,0.85)" }}>
              • {item}
            </Typography>
            <IconButton size="small" onClick={() => onRemove(index)} sx={{ color: "rgba(255,255,255,0.5)" }}>
              <DeleteOutline fontSize="small" />
            </IconButton>
          </Box>
        ))}
        {items.length === 0 && (
          <Typography sx={{ fontSize: 13, color: "rgba(255,255,255,0.4)", fontStyle: "italic" }}>
            No points added yet.
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}


export default BulletListEditor;